import { gql } from '@apollo/client';

export const FULL_NAME = gql`
  query getFullName($customerAccessToken: String!) {
    customerAccessToken @client @export(as: "customerAccessToken")
    customer(customerAccessToken: $customerAccessToken) {
      id
      firstName
      lastName
    }
  }
`;

/**
 * current account frequencies for the user (SMS/EMAIL)
 */
export const GET_ACCOUNT_SUBSCRIPTION = gql`
  query getAccountSubscription(
    $hashedEmail: String!
    $type: AccountSubscriptionType
  ) {
    accountSubscription(hashedEmail: $hashedEmail, type: $type) {
      id
      subscriptionFrequency {
        id
        frequency
        label
      }
    }
    campaignId @client
    previousSubscriptionStatus @client
  }
`;

export default {};
